import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  adminInstance as axios,
} from '~/utils';

import { PseudoStates, PageTitle } from '@cordata/buffet';
import SendgridEventForm from '~/components/SendgridEvent/Form';

const SendgridEventDetails = () => {
  const params = useParams();
  const history = useHistory();
  const [event, setEvent] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    axios
      .get(`/sendgrid_event/${params.event_id}`)
      .then(response => {
        const eventData = response.data.data;
        setEvent(eventData);
      })
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, [params.event_id]);

  if (isLoading || error) {
    return (
      <PseudoStates
        isLoading={isLoading}
        error={error}
      />
    );
  }

  return (
    <>
      <PageTitle
        action={
          <Button
            color="secondary"
            size="sm"
            onClick={() => history.push('/admin/sendgrid-events')}
          >
            <FontAwesomeIcon icon="arrow-left" className="mr-2" />
            Back to List
          </Button>
        }
      >
        Sendgrid Event Details
      </PageTitle>

      <SendgridEventForm event={event} />
    </>
  );
};

SendgridEventDetails.propTypes = {};

export default SendgridEventDetails;
